'use client'
import { cn } from '@/util/cn'
import Link from 'next/link'
import { ReactNode } from 'react'
import styled from 'styled-components'
const Container = styled.div`
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`

const H = styled.h2``

type Props = {
    Icon?: ReactNode
    link?: string
    // support for legacy pages like /stories
    isHref?: boolean
    label?: ReactNode
    className?: string
    children?: ReactNode
    // naming this `as` can mess up types
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const spacingClassName = 'mb-0.5 px-2 md:px-0'
const headerContainerClassName = 'flex items-center justify-between'

/**
 * has standardized padding
 */
export const HeaderRow = ({ className, children }: { className?: string; children: ReactNode }) => {
    return <Container className={cn(spacingClassName, className)}>{children}</Container>
}

export const SectionHeader = ({ Icon, label, className = '', tag = 'h4', link, isHref, children }: Props) => {
    const Row = () => (
        <HeaderRow className={cn(headerContainerClassName, className)}>
            {label && (
                <div className="flex items-center gap-1.5">
                    {Icon}
                    <H as={tag}>{label}</H>
                    {link && (
                        <div className="ss-icon ss-navigateright inline-block h-[13px] text-xs text-giphyLightGrey"></div>
                    )}
                </div>
            )}
            {children}
        </HeaderRow>
    )
    return link ? (
        isHref ? (
            <a href={link}>
                <Row />
            </a>
        ) : (
            <Link href={link}>
                <Row />
            </Link>
        )
    ) : (
        <Row />
    )
}
